import config from '../config/environment';

export const getCanonicalUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${config.frontendUrl}/${cleanPath}`;
};

export const getMenuUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${config.frontendUrl}/${cleanPath}/menu`;
};

export const getImageUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${config.frontendUrl}/${cleanPath}`;
}; 